import { VNROUTES_CLEAR_ROUTE, VNROUTES_SET_ROUTE } from './ActionTypes'

/**
 * Set Route Action
 *
 * @param {String} route
 * @param {?Object} params
 * @returns {Object}
 */
export const setRouteAction = (route, params = null) => {
  return {
    type: VNROUTES_SET_ROUTE,
    route,
    params,
  }
}

/**
 * Clear Route Action
 *
 * @returns {Object}
 */
export const clearRouteAction = () => {
  return {
    type: VNROUTES_CLEAR_ROUTE,
  }
}
